import { Loading } from '@spoiler-alert/ui-library';
import PropTypes from 'prop-types';
import React, { Suspense } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { InternalLayout, Layout } from './layouts';
import routePaths from './route-paths';
import { SupportService } from './services';

const UnAuthedRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (
      <Layout {...props}>
        <Component {...props} />
      </Layout>
    )}
  />
);

UnAuthedRoute.propTypes = {
  component: PropTypes.any,
};

const NoTemplateRoute = ({ component: Component, ...rest }) => <Route {...rest} render={(props) => <Component {...props} />} />;

NoTemplateRoute.propTypes = {
  component: PropTypes.any,
};

const SupportRoute = ({ ...rest }) => (
  <Route
    {...rest}
    render={async () => {
      window.location = 'https://spoileralert.kustomer.help/';
    }}
  />
);

SupportRoute.propTypes = {
  component: PropTypes.any,
  location: PropTypes.object,
};

class AuthedRoute extends React.Component {
  render() {
    const { component, guard, redirectPath, user, ...rest } = this.props;
    const Component = component;
    return (
      <Route
        {...rest}
        render={(props) => {
          const signInPage = localStorage.getItem('isSSOUser') === 'yes' ? routePaths.ssoSignIn : routePaths.signIn;
          const legacyToken = localStorage.getItem('token');
          const isLoggedIn = localStorage.getItem('loggedIn');
          if (!isLoggedIn && !legacyToken) return <Redirect to={`${signInPage}?redirect=${props.location.pathname}`} />;
          const guardCheck = guard(user);
          if (!guardCheck.isValid) return <Redirect to={redirectPath || guardCheck.redirect || routePaths.home} />;
          return (
            <Suspense fallback={<Loading loading={true} />}>
              <InternalLayout user={user} {...props} {...rest}>
                <Component user={user} {...props} {...rest} />
              </InternalLayout>
            </Suspense>
          );
        }}
      />
    );
  }
}

const RedirectRoute = ({ ...rest }) => <Redirect to={rest.redirectPath} />;

AuthedRoute.propTypes = {
  user: PropTypes.object,
  component: PropTypes.any,
  guard: PropTypes.func,
  redirectPath: PropTypes.string,
  isOn: PropTypes.any,
  isOff: PropTypes.any,
  featureFlag: PropTypes.string,
};

AuthedRoute.defaultProps = {
  guard: () => ({ isValid: true }),
};

export { AuthedRoute, NoTemplateRoute, RedirectRoute, SupportRoute, UnAuthedRoute };
